export class Documento {

  Id: number;
  Descricao: string;
  Ativo: boolean;
  constructor() {
    this.Id = 0;
    this.Descricao = '';
    this.Ativo = true;
  }
}
